<button
  [attr.aria-label]="'a11y.link.settings' | translate"
  [matMenuTriggerFor]="menu"
  class="toolbar__menu-item"
  mat-button
  tabIndex="0">
  {{ 'menu.label.account' | translate }}
  <mat-icon class="material-icons">expand_more</mat-icon>
</button>

<mat-menu #menu="matMenu">
  @for (accountItem of accountMenuItems(); track accountItem.route) {
    <a
      [attr.aria-label]="accountItem.ariaLabel | translate"
      [routerLink]="accountItem.route"
      [title]="accountItem.ariaLabel | translate"
      mat-menu-item
      role="menuitem"
      >{{ accountItem.label | translate }}
    </a>
  }
  <mat-divider />
  <button mat-menu-item role="menuitem" routerLink="/logout">
    <mat-icon>logout</mat-icon>
    <span>{{ 'menu.label.logout' | translate }}</span>
  </button>
</mat-menu>
